import { ConfirmModalEntry } from '../modal-manager.state';
import { ModalResult } from '../modal-manager.types';
import { ModalFrame } from './ModalFrame';

type ConfirmModalProps = {
  entry: ConfirmModalEntry;
  stackIndex: number;
  isTopmost: boolean;
  onResolve: (modalId: string, result: { result: ModalResult }) => void;
};

export const ConfirmModal = ({ entry, stackIndex, isTopmost, onResolve }: ConfirmModalProps) => {
  const confirm = () => onResolve(entry.modalId, { result: ModalResult.Confirm });
  const cancel = () => onResolve(entry.modalId, { result: ModalResult.Cancel });
  const close = () => onResolve(entry.modalId, { result: ModalResult.Closed });

  return (
    <ModalFrame
      title={entry.options.title}
      size={entry.options.size}
      stackIndex={stackIndex}
      isTopmost={isTopmost}
      onClose={close}
      renderFooter={entry.options.renderFooter?.({ confirm, cancel, close })}
      defaultFooter={{
        confirmButton: { ...entry.options.confirmButton, onClick: confirm },
        cancelButton: { ...entry.options.cancelButton, onClick: cancel },
      }}
    >
      {entry.options.renderBody()}
    </ModalFrame>
  );
};
